const SALDOCLIENTE_HARDCODED = {
  limiteCredito: 30000000,
  limiteRestante: 12291784.0487,
  saldoCtaCte: -100000,
  chequesTerceros: 0,
  remitosNoFacturados: 17808215.9513,
  pedidosNoRemitidosYNoFacturados: 0,
};

const getSaldo = async idCliente => {
  return SALDOCLIENTE_HARDCODED;
};

const SaldoCliente = {
  getSaldo,
};

export default SaldoCliente;
